const config = {
  client_id:
    "575412109893-clfpajd235fpk9tllnilac2n3et81nvh.apps.googleusercontent.com",
  api_url:
    "https://jahtdfhx64.execute-api.us-west-2.amazonaws.com/IC_CMS_STAGE-01",
  //"http://localhost:98/",
  url: "https://www.mordorintelligence.com/",
};

export default config;



// WEBPACK FOOTER //
// ./src/config/api.js